/* cf-preview-mobile-band.js
 * Click Fencing - the fence drawing on a phone: keep it in view, and make it obvious
 * that a long fence scrolls.
 * Pete 2026-08-28: "the graphics dont float when you scroll down the page and you cant
 * scroll right with aluminium fences graphics when they dont fit."
 *
 * Measured on an emulated iPhone 14 Pro, blade at 20,000mm:
 *   #section-preview   clientWidth 327, scrollWidth 1491, overflow-x auto  -> 1,164px hidden
 *   .panels-container  width 1443px, min-width 100%, flex 0 0 auto         -> sized to content
 * Setting scrollLeft on #section-preview DOES move it, so the box can scroll. What it has
 * on a phone is no scrollbar and no edge cue, so the fence simply looks cut off - which is
 * exactly what Pete reported. Glass was fine because its drawing is narrow enough to fit.
 *
 * So this does two things, MOBILE ONLY (<=749px), and nothing on desktop where the
 * scrollbar already tells the story:
 *
 *   1. FLOAT - the drawing stays on screen while the customer scrolls the section options
 *      underneath it.
 *
 *      position:sticky CANNOT be used here, and this is the trap worth remembering:
 *      cf-mobile puts the sideways-scroll guard on BODY, so body computes to
 *      overflow-x:hidden / overflow-y:auto. That makes BODY a scrollport, and a sticky
 *      element inside a scrollport that never itself scrolls simply never sticks - measured,
 *      the band scrolled away to top:-441 with position:sticky applied and honoured.
 *      Setting body overflow:visible fixes sticky and immediately brings back 17px of
 *      page-level sideways scroll, i.e. it trades one bug for the one that guard exists to
 *      stop. So the float is done in JS with position:fixed plus a placeholder that holds
 *      the layout, which depends on nothing about the ancestors.
 *
 *   2. SCROLL - a left and right chevron are laid over the ends of the band, each shown only
 *      while there is more fence in that direction, tapping scrolls by 60% of the band. Tap
 *      targets are 40px, well over the 44px-ish minimum once padding is counted, and they
 *      work regardless of how the browser interprets a horizontal swipe inside a 136px
 *      strip. A soft edge fade backs them up.
 *
 *   3. The band also carries a THIRD "Next" button (#preview-next-btn, absolutely positioned
 *      inside the drawing) which sits on top of the fence on a phone - Pete flagged it, and
 *      once the band floats it also lands on the scroll chevron. It is hidden on mobile:
 *      the same step still has the Next above the band and the full-width Next at the
 *      bottom, so nothing is lost.
 *
 * Display only - touches no price, product, quantity or cart line.
 */
(function () {
  if (window.__cfPreviewMobileBandPatched) return;
  window.__cfPreviewMobileBandPatched = true;

  var MOBILE = 749;
  var ARROW = 'data-cf-band-arrow';
  var FADE = 'data-cf-band-fade';

  function isMobile() { return window.innerWidth <= MOBILE; }

  // the drawing's scroller is the element itself, or whichever ancestor actually clips it.
  // NB glass draws its preview in plain divs, not an <svg>, so this must start from the
  // preview containers rather than from an svg - keying on svg gave glass no chevrons even
  // though it was hiding ~100px of fence.
  function scrollerFrom(el) {
    var e = el;
    while (e && e !== document.body) {
      var cs = getComputedStyle(e);
      if ((cs.overflowX === 'auto' || cs.overflowX === 'scroll') && e.scrollWidth > e.clientWidth + 2) return e;
      e = e.parentElement;
    }
    return null;
  }

  function strip(host) {
    var kids = host.querySelectorAll('[' + ARROW + '], [' + FADE + ']');
    for (var i = 0; i < kids.length; i++) kids[i].parentNode.removeChild(kids[i]);
  }

  function decorate(scroller) {
    var host = scroller.parentElement;
    if (!host) return;
    if (getComputedStyle(host).position === 'static') host.style.position = 'relative';

    var made = host.querySelector('[' + ARROW + '="right"]');
    if (!made) {
      strip(host);
      var mk = function (side, glyph) {
        var b = document.createElement('button');
        b.type = 'button';
        b.setAttribute(ARROW, side);
        b.setAttribute('aria-label', side === 'left' ? 'Scroll fence left' : 'Scroll fence right');
        b.textContent = glyph;
        b.style.cssText = 'position:absolute;top:50%;' + side + ':4px;transform:translateY(-50%);' +
          'width:40px;height:40px;border-radius:50%;border:1px solid #cbd5e1;background:rgba(255,255,255,.92);' +
          'color:#0f172a;font:700 20px/1 system-ui,sans-serif;display:none;align-items:center;' +
          'justify-content:center;cursor:pointer;z-index:6;box-shadow:0 1px 4px rgba(0,0,0,.18);padding:0;';
        b.addEventListener('click', function (ev) {
          ev.preventDefault(); ev.stopPropagation();
          var by = Math.round(scroller.clientWidth * 0.6);
          scroller.scrollBy({ left: side === 'left' ? -by : by, behavior: 'smooth' });
        });
        host.appendChild(b);
        return b;
      };
      var mkFade = function (side) {
        var d = document.createElement('div');
        d.setAttribute(FADE, side);
        d.style.cssText = 'position:absolute;top:0;bottom:0;' + side + ':0;width:34px;pointer-events:none;z-index:5;' +
          'display:none;background:linear-gradient(to ' + (side === 'left' ? 'right' : 'left') +
          ',rgba(255,255,255,.95),rgba(255,255,255,0));';
        host.appendChild(d);
        return d;
      };
      mkFade('left'); mkFade('right');
      mk('left', '‹'); mk('right', '›');
      scroller.addEventListener('scroll', function () { sync(scroller); }, { passive: true });
    }
    // touch scrolling, belt and braces
    scroller.style.setProperty('-webkit-overflow-scrolling', 'touch');
    scroller.style.setProperty('touch-action', 'pan-x pan-y');
    sync(scroller);
  }

  function sync(scroller) {
    var host = scroller.parentElement;
    if (!host) return;
    var max = scroller.scrollWidth - scroller.clientWidth;
    var left = scroller.scrollLeft;
    var show = function (sel, on) {
      var el = host.querySelector(sel);
      if (el) el.style.display = on ? (el.hasAttribute(ARROW) ? 'flex' : 'block') : 'none';
    };
    var canL = max > 4 && left > 4, canR = max > 4 && left < max - 4;
    show('[' + ARROW + '="left"]', canL);   show('[' + FADE + '="left"]', canL);
    show('[' + ARROW + '="right"]', canR);  show('[' + FADE + '="right"]', canR);
  }

  // --- the float, done by hand because sticky is unavailable (see the header) ---

  function placeholderFor(w) {
    var ph = w.__cfPh;
    if (!ph || !ph.parentNode) {
      ph = document.createElement('div');
      ph.setAttribute('data-cf-band-ph', '1');
      ph.style.cssText = 'display:none;';
      w.parentNode.insertBefore(ph, w);
      w.__cfPh = ph;
    }
    return ph;
  }

  function unfloat(w) {
    var ph = w.__cfPh;
    w.style.removeProperty('position'); w.style.removeProperty('top');
    w.style.removeProperty('left'); w.style.removeProperty('width');
    w.style.removeProperty('z-index'); w.style.removeProperty('background');
    w.style.removeProperty('box-shadow');
    if (ph) ph.style.display = 'none';
    w.__cfFloating = false;
  }

  function styleFloat(w, box) {
    w.style.setProperty('position', 'fixed', 'important');
    w.style.setProperty('top', '0px', 'important');
    w.style.setProperty('left', Math.round(box.left) + 'px', 'important');
    w.style.setProperty('width', Math.round(box.width) + 'px', 'important');
    w.style.setProperty('z-index', '40', 'important');
    w.style.setProperty('background', '#fff', 'important');
    w.style.setProperty('box-shadow', '0 2px 6px rgba(0,0,0,.10)', 'important');
  }

  function floatBand() {
    var wraps = document.querySelectorAll('.live-preview-wrapper');
    for (var i = 0; i < wraps.length; i++) {
      var w = wraps[i];
      if (!isMobile() || !w.getClientRects().length) { if (w.__cfFloating) unfloat(w); continue; }

      var ph = placeholderFor(w);
      var floating = !!w.__cfFloating;
      var anchor = floating ? ph : w;
      var rect = anchor.getBoundingClientRect();
      var h = floating ? (ph.__cfH || rect.height) : rect.height;

      var tab = w.closest('.tab-content') || w.parentElement;
      var tabBottom = tab.getBoundingClientRect().bottom;

      // Hysteresis on the "is there still room below" test, and NO DOM writes at all while
      // the state is unchanged. Pete 2026-08-29: "when i scroll to the bottom of the page in
      // the calculator it wont let me scroll up." Writing layout on every scroll event, and
      // flipping float state at a boundary that the scroll itself moves, fights the finger -
      // each toggle relays out the page mid-gesture and the browser drops the drag. Engage
      // needs 160px of section left below the band; release only once it is under 60px.
      var next = floating
        ? (rect.top <= 0 && tabBottom > h + 60)
        : (rect.top <= 0 && tabBottom > h + 160);
      // 2026-10-08: a phone drawing in rows (cf-preview-phone.js) can be 300-500px tall; pinning that
      // would cover the screen, so only a band up to 240px is pinned.
      if (next && (floating ? w.getBoundingClientRect().height : h) > 240) next = false;

      if (next === floating) continue;

      if (next) {
        ph.__cfH = h;
        ph.style.display = 'block';
        ph.style.height = h + 'px';
        w.__cfFloating = true;
        styleFloat(w, ph.getBoundingClientRect());
      } else {
        unfloat(w);
      }
    }
  }

  function trimBandNext() {
    var b = document.getElementById('preview-next-btn');
    if (!b) return;
    if (isMobile()) b.style.setProperty('display', 'none', 'important');
    else b.style.removeProperty('display');
  }

  function apply() {
    try { floatBand(); } catch (e) {}
    try { trimBandNext(); } catch (e) {}
    var cands = document.querySelectorAll(
      '#section-preview, .section-preview-wrapper, .visual-preview, .panels-container, ' +
      '.panel-preview, #section-preview svg, .panels-container svg');
    var done = [];
    for (var i = 0; i < cands.length; i++) {
      try {
        var sc = scrollerFrom(cands[i]);
        if (!sc || done.indexOf(sc) !== -1) continue;
        done.push(sc);
        if (!isMobile()) { strip(sc.parentElement || document.body); continue; }
        decorate(sc);
      } catch (e) {}
    }
  }

  var queued = false;
  function schedule() {
    if (queued) return;
    queued = true;
    (window.requestAnimationFrame || setTimeout)(function () { queued = false; apply(); }, 0);
  }

  try {
    new MutationObserver(schedule).observe(document.documentElement, {
      childList: true, subtree: true, characterData: true
    });
  } catch (e) {}
  window.addEventListener('resize', function () {
    try {
      var ws = document.querySelectorAll('.live-preview-wrapper');
      for (var i = 0; i < ws.length; i++) if (ws[i].__cfFloating) unfloat(ws[i]);
    } catch (e) {}
    schedule();
  });
  window.addEventListener('scroll', function () { try { floatBand(); } catch (e) {} }, { passive: true });

  // permanent safety net - same reason as cf-gate-hinge-latch.js: the observer alone has
  // been seen to miss a preview redraw
  setInterval(apply, 1200);

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', apply);
  apply();
  console.log('[cf-preview-mobile-band] installed');
})();
